import axios from 'src/utils/axios';
import helpers from 'src/helpers';
import { NOTIFICATION_STATUS } from 'src/constants';
import { addNotification } from 'src/actions/notificationActions';

// Action Types
export const GET_SMART_FIELD_DEFINITIONS = '@smart-fields/get-definitions';
export const GET_SMART_FIELD_DEFINITIONS_SUCCESS = '@smart-fields/get-definitions-success';
export const GET_SMART_FIELD_DEFINITIONS_ERROR = '@smart-fields/get-definitions-error';
export const CLEAR_SMART_FIELD_DEFINITIONS = '@smart-fields/clear-definitions';

export const GET_SMART_FIELD_DEFINITION = '@smart-fields/get-definition';
export const GET_SMART_FIELD_DEFINITION_SUCCESS = '@smart-fields/get-definition-success';
export const GET_SMART_FIELD_DEFINITION_ERROR = '@smart-fields/get-definition-error';
export const CLEAR_SMART_FIELD_DEFINITION = '@smart-fields/clear-definition';

export const CREATE_SMART_FIELD_DEFINITION = '@smart-fields/create-definition';
export const CREATE_SMART_FIELD_DEFINITION_SUCCESS = '@smart-fields/create-definition-success';
export const CREATE_SMART_FIELD_DEFINITION_ERROR = '@smart-fields/create-definition-error';

export const UPDATE_SMART_FIELD_DEFINITION = '@smart-fields/update-definition';
export const UPDATE_SMART_FIELD_DEFINITION_SUCCESS = '@smart-fields/update-definition-success';
export const UPDATE_SMART_FIELD_DEFINITION_ERROR = '@smart-fields/update-definition-error';

export const DELETE_SMART_FIELD_DEFINITION = '@smart-fields/delete-definition';
export const DELETE_SMART_FIELD_DEFINITION_SUCCESS = '@smart-fields/delete-definition-success';
export const DELETE_SMART_FIELD_DEFINITION_ERROR = '@smart-fields/delete-definition-error';

export const DUPLICATE_SMART_FIELD_DEFINITION = '@smart-fields/duplicate-definition';
export const DUPLICATE_SMART_FIELD_DEFINITION_SUCCESS = '@smart-fields/duplicate-definition-success';
export const DUPLICATE_SMART_FIELD_DEFINITION_ERROR = '@smart-fields/duplicate-definition-error';
export const CLEAR_DEFINITION_WAS_DELETED = '@smart-fields/clear-definition-was-deleted';

export const SET_SMART_FIELDS_QUERY = '@smart-fields/set-query';
export const CLEAR_SMART_FIELDS_QUERY_FILTER = '@smart-fields/clear-query-filter';
export const SET_BACK_TO_SMART_FIELDS_LIST = '@smart-fields/set-back-to-list';
export const SET_CURRENT_NAVIGATION_TAB = '@smart-fields/set-current-navigation-tab';

// Picker-specific action types (for dynamic field picker)
export const GET_SMART_FIELD_DEFINITIONS_FOR_PICKER = '@smart-fields/get-definitions-for-picker';
export const GET_SMART_FIELD_DEFINITIONS_FOR_PICKER_SUCCESS = '@smart-fields/get-definitions-for-picker-success';
export const GET_SMART_FIELD_DEFINITIONS_FOR_PICKER_ERROR = '@smart-fields/get-definitions-for-picker-error';

// Group Member Smart Fields action types
export const GET_GROUP_MEMBER_SMART_FIELDS = '@smart-fields/get-group-member-smart-fields';
export const GET_GROUP_MEMBER_SMART_FIELDS_SUCCESS = '@smart-fields/get-group-member-smart-fields-success';
export const GET_GROUP_MEMBER_SMART_FIELDS_ERROR = '@smart-fields/get-group-member-smart-fields-error';
export const UPDATE_GROUP_MEMBER_SMART_FIELDS = '@smart-fields/update-group-member-smart-fields';
export const UPDATE_GROUP_MEMBER_SMART_FIELDS_SUCCESS = '@smart-fields/update-group-member-smart-fields-success';
export const UPDATE_GROUP_MEMBER_SMART_FIELDS_ERROR = '@smart-fields/update-group-member-smart-fields-error';
export const CLEAR_GROUP_MEMBER_SMART_FIELDS = '@smart-fields/clear-group-member-smart-fields';

// Party Guest Smart Fields action types
export const GET_PARTY_GUEST_SMART_FIELDS = '@smart-fields/get-party-guest-smart-fields';
export const GET_PARTY_GUEST_SMART_FIELDS_SUCCESS = '@smart-fields/get-party-guest-smart-fields-success';
export const GET_PARTY_GUEST_SMART_FIELDS_ERROR = '@smart-fields/get-party-guest-smart-fields-error';
export const UPDATE_PARTY_GUEST_SMART_FIELDS = '@smart-fields/update-party-guest-smart-fields';
export const UPDATE_PARTY_GUEST_SMART_FIELDS_SUCCESS = '@smart-fields/update-party-guest-smart-fields-success';
export const UPDATE_PARTY_GUEST_SMART_FIELDS_ERROR = '@smart-fields/update-party-guest-smart-fields-error';
export const CLEAR_PARTY_GUEST_SMART_FIELDS = '@smart-fields/clear-party-guest-smart-fields';

// Contact Smart Fields action types
export const GET_CONTACT_SMART_FIELDS = '@smart-fields/get-contact-smart-fields';
export const GET_CONTACT_SMART_FIELDS_SUCCESS = '@smart-fields/get-contact-smart-fields-success';
export const GET_CONTACT_SMART_FIELDS_ERROR = '@smart-fields/get-contact-smart-fields-error';
export const UPDATE_CONTACT_SMART_FIELDS = '@smart-fields/update-contact-smart-fields';
export const UPDATE_CONTACT_SMART_FIELDS_SUCCESS = '@smart-fields/update-contact-smart-fields-success';
export const UPDATE_CONTACT_SMART_FIELDS_ERROR = '@smart-fields/update-contact-smart-fields-error';
export const CLEAR_CONTACT_SMART_FIELDS = '@smart-fields/clear-contact-smart-fields';

// Action Creators

export const setCurrentNavigationTab = (tab) => ({
  type: SET_CURRENT_NAVIGATION_TAB,
  payload: tab,
});

export const setSmartFieldsQuery = (query) => ({
  type: SET_SMART_FIELDS_QUERY,
  payload: query
});

export const setBackToSmartFieldsList = (payload) => ({
  type: SET_BACK_TO_SMART_FIELDS_LIST,
  payload,
});

export const clearBackToSmartFieldsList = (clearAll = false) => ({
  type: SET_BACK_TO_SMART_FIELDS_LIST,
  payload: !clearAll ? {
    definitions: [],
    query: {},
  } : false,
});

export const clearSmartFieldsQueryFilter = () => ({
  type: CLEAR_SMART_FIELDS_QUERY_FILTER,
});

export const getSmartFieldDefinitions = () => async (dispatch, getState) => {
  dispatch({
    type: GET_SMART_FIELD_DEFINITIONS,
  });
  try {
    const query = getState()?.smartFields?.query || {};
    const params = {};

    // Entity type filter
    if (query.entityType && query.entityType !== 'All') {
      params.entityType = query.entityType;
    }

    // Status filter
    if (query.status && query.status !== 'All') {
      params.status = query.status;
    }

    // Sort params
    if (query.sort && query.sort.length > 0) {
      const [sortField, sortDirection] = query.sort[0];
      params.sortBy = sortField;
      params.sortOrder = sortDirection;
    }

    // Advanced filters
    const { filters } = query || {};
    if (filters) {
      if (filters.fieldType) {
        params.fieldType = filters.fieldType;
      }
      if (filters.category) {
        params.category = filters.category;
      }
      if (filters.isSystemFilter) {
        params.isSystemFilter = filters.isSystemFilter;
      }
    }

    const response = await axios.get('/api/smart-fields/definitions', { params });
    dispatch({
      type: GET_SMART_FIELD_DEFINITIONS_SUCCESS,
      payload: response?.data?.definitions || [],
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(
      GET_SMART_FIELD_DEFINITIONS_ERROR,
      helpers.transform.toString(message || error || 'Server error'),
      NOTIFICATION_STATUS.ERROR
    ));
    dispatch({
      type: GET_SMART_FIELD_DEFINITIONS_ERROR,
    });
  }
};

export const getSmartFieldDefinition = (definitionId) => async (dispatch) => {
  dispatch({
    type: GET_SMART_FIELD_DEFINITION,
  });
  try {
    // For now, we'll get the definition from the list
    // In the future, we could add a dedicated endpoint
    const response = await axios.get('/api/smart-fields/definitions');
    const definitions = response?.data?.definitions || [];
    const definition = definitions.find((d) => String(d.id) === String(definitionId));

    if (definition) {
      dispatch({
        type: GET_SMART_FIELD_DEFINITION_SUCCESS,
        payload: definition,
      });
    } else {
      dispatch(addNotification(
        GET_SMART_FIELD_DEFINITION_ERROR,
        'Smart field definition not found',
        NOTIFICATION_STATUS.ERROR
      ));
      dispatch({
        type: GET_SMART_FIELD_DEFINITION_ERROR,
      });
    }
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(
      GET_SMART_FIELD_DEFINITION_ERROR,
      helpers.transform.toString(message || error || 'Server error'),
      NOTIFICATION_STATUS.ERROR
    ));
    dispatch({
      type: GET_SMART_FIELD_DEFINITION_ERROR,
    });
  }
};

export const createSmartFieldDefinition = (
  payload,
  doWhenTry = false,
  doWhenCatch = false
) => async (dispatch) => {
  try {
    dispatch({
      type: CREATE_SMART_FIELD_DEFINITION,
    });
    const response = await axios.post('/api/smart-fields/definitions', payload);
    const { definition } = response?.data || {};

    if (!definition?.id) {
      dispatch(addNotification(
        CREATE_SMART_FIELD_DEFINITION_ERROR,
        'Cannot create smart field',
        NOTIFICATION_STATUS.ERROR
      ));
      dispatch({
        type: CREATE_SMART_FIELD_DEFINITION_ERROR,
      });
      return;
    }

    dispatch(addNotification(
      CREATE_SMART_FIELD_DEFINITION_SUCCESS,
      `Smart field "${definition.fieldLabel}" has been successfully created`,
      NOTIFICATION_STATUS.SUCCESS
    ));
    dispatch({
      type: CREATE_SMART_FIELD_DEFINITION_SUCCESS,
    });

    if (doWhenTry) {
      doWhenTry(definition);
    }
  } catch (e) {
    const {
      message,
      error,
    } = e?.response?.data || {};
    dispatch(addNotification(
      CREATE_SMART_FIELD_DEFINITION_ERROR,
      helpers.transform.toString(message || error || 'Server error'),
      NOTIFICATION_STATUS.ERROR
    ));
    dispatch({
      type: CREATE_SMART_FIELD_DEFINITION_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const updateSmartFieldDefinition = (
  id,
  payload,
  doWhenTry = false,
  doWhenCatch = false
) => async (dispatch) => {
  try {
    dispatch({
      type: UPDATE_SMART_FIELD_DEFINITION,
    });
    const response = await axios.put(`/api/smart-fields/definitions/${id}`, payload);
    const { definition } = response?.data || {};

    dispatch(addNotification(
      UPDATE_SMART_FIELD_DEFINITION_SUCCESS,
      'Smart field has been successfully updated',
      NOTIFICATION_STATUS.SUCCESS
    ));
    dispatch({
      type: UPDATE_SMART_FIELD_DEFINITION_SUCCESS,
      payload: definition,
    });

    if (doWhenTry) {
      doWhenTry(definition?.id);
    }
  } catch (e) {
    const {
      message,
      error,
    } = e?.response?.data || {};
    dispatch(addNotification(
      UPDATE_SMART_FIELD_DEFINITION_ERROR,
      helpers.transform.toString(message || error || 'Server error'),
      NOTIFICATION_STATUS.ERROR
    ));
    dispatch({
      type: UPDATE_SMART_FIELD_DEFINITION_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const deleteSmartFieldDefinition = (
  id,
  doWhenTry = false,
  doWhenCatch = false
) => async (dispatch) => {
  dispatch({
    type: DELETE_SMART_FIELD_DEFINITION,
  });
  try {
    const response = await axios.delete(`/api/smart-fields/definitions/${id}`);
    const isSuccess = response?.data?.success;

    if (!isSuccess) {
      dispatch(addNotification(
        DELETE_SMART_FIELD_DEFINITION_ERROR,
        'Cannot delete smart field',
        NOTIFICATION_STATUS.ERROR
      ));
      dispatch({
        type: DELETE_SMART_FIELD_DEFINITION_ERROR,
      });
      return;
    }

    dispatch(addNotification(
      DELETE_SMART_FIELD_DEFINITION_SUCCESS,
      'Smart field has been successfully deleted',
      NOTIFICATION_STATUS.SUCCESS
    ));
    dispatch({
      type: DELETE_SMART_FIELD_DEFINITION_SUCCESS,
    });

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(
      DELETE_SMART_FIELD_DEFINITION_ERROR,
      helpers.transform.toString(message || error || 'Server error'),
      NOTIFICATION_STATUS.ERROR
    ));
    dispatch({
      type: DELETE_SMART_FIELD_DEFINITION_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

/**
 * Row-kebab duplicate (CON-1619). The server copies the caller's own
 * definition with a "<base> - Copy" name and echoes the generated name.
 */
export const duplicateSmartFieldDefinition = (id, onSuccess, onError) => async (dispatch) => {
  try {
    dispatch({ type: DUPLICATE_SMART_FIELD_DEFINITION });
    const response = await axios.post(`/api/smart-fields/definitions/${id}/duplicate`);
    const { id: newId, generatedName } = response?.data || {};

    dispatch({ type: DUPLICATE_SMART_FIELD_DEFINITION_SUCCESS });
    dispatch(addNotification(
      DUPLICATE_SMART_FIELD_DEFINITION_SUCCESS,
      generatedName
        ? `Smart Field "${generatedName}" has been successfully created`
        : 'Your Smart Field has been successfully created',
      NOTIFICATION_STATUS.SUCCESS
    ));

    if (onSuccess) onSuccess(newId);
  } catch (e) {
    const { error, message } = e?.response?.data || {};
    dispatch({ type: DUPLICATE_SMART_FIELD_DEFINITION_ERROR });
    dispatch(addNotification(
      DUPLICATE_SMART_FIELD_DEFINITION_ERROR,
      helpers.transform.toString(message || error || 'Try again later'),
      NOTIFICATION_STATUS.ERROR
    ));
    if (onError) onError(e);
  }
};

export const clearSmartFieldDefinitions = () => async (dispatch) => {
  dispatch({
    type: CLEAR_SMART_FIELD_DEFINITIONS,
  });
};

export const clearSmartFieldDefinition = () => async (dispatch) => {
  dispatch({
    type: CLEAR_SMART_FIELD_DEFINITION,
  });
};

export const clearDefinitionWasDeleted = () => async (dispatch) => {
  dispatch({
    type: CLEAR_DEFINITION_WAS_DELETED,
  });
};

export const reorderSmartFieldDefinitions = (
  updates,
  doWhenTry = false,
  doWhenCatch = false
) => async (dispatch) => {
  try {
    await axios.put('/api/smart-fields/definitions/reorder', { updates });

    if (doWhenTry) {
      doWhenTry();
    }

    // Refresh the list to show updated sort order
    dispatch(getSmartFieldDefinitions());
  } catch (e) {
    const {
      message,
      error,
    } = e?.response?.data || {};
    dispatch(addNotification(
      'REORDER_SMART_FIELD_DEFINITIONS_ERROR',
      helpers.transform.toString(message || error || 'Failed to reorder fields'),
      NOTIFICATION_STATUS.ERROR
    ));

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

/**
 * getSmartFieldDefinitionsForPicker
 * Fetches active Smart Field definitions for the dynamic field picker.
 * Accepts a single entity type string OR an array of entity types.
 * When an array is provided, fetches each in parallel and merges results.
 */
export const getSmartFieldDefinitionsForPicker = (
  entityType = 'GroupMember',
) => async (dispatch) => {
  dispatch({
    type: GET_SMART_FIELD_DEFINITIONS_FOR_PICKER,
  });
  try {
    const entityTypes = Array.isArray(entityType) ? entityType : [entityType];
    const baseParams = {
      status: 'Active',
      sortBy: 'sort',
      sortOrder: 'asc',
    };

    const responses = await Promise.all(
      entityTypes.map((et) => axios.get('/api/smart-fields/definitions', {
        params: { ...baseParams, entityType: et },
      }))
    );

    const allDefinitions = responses.flatMap(
      (response) => response?.data?.definitions || []
    );

    dispatch({
      type: GET_SMART_FIELD_DEFINITIONS_FOR_PICKER_SUCCESS,
      payload: allDefinitions,
    });
  } catch (e) {
    // Silently fail for picker - don't show error notification
    dispatch({
      type: GET_SMART_FIELD_DEFINITIONS_FOR_PICKER_ERROR,
    });
  }
};

/**
 * getGroupMemberSmartFields
 * Fetches the smart field values for a specific group member
 */
export const getGroupMemberSmartFields = (groupMemberId) => async (dispatch) => {
  dispatch({
    type: GET_GROUP_MEMBER_SMART_FIELDS,
  });
  try {
    const response = await axios.get(`/api/smart-fields/group-member/${groupMemberId}`);
    dispatch({
      type: GET_GROUP_MEMBER_SMART_FIELDS_SUCCESS,
      payload: response?.data || {},
    });
    return response?.data;
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(
      GET_GROUP_MEMBER_SMART_FIELDS_ERROR,
      helpers.transform.toString(message || error || 'Failed to load smart fields'),
      NOTIFICATION_STATUS.ERROR
    ));
    dispatch({
      type: GET_GROUP_MEMBER_SMART_FIELDS_ERROR,
    });
    return null;
  }
};

/**
 * updateGroupMemberSmartFields
 * Updates the smart field values for a specific group member
 */
export const updateGroupMemberSmartFields = (
  groupMemberId,
  smartFields,
  doWhenTry = false,
  doWhenCatch = false
) => async (dispatch) => {
  dispatch({
    type: UPDATE_GROUP_MEMBER_SMART_FIELDS,
  });
  try {
    const response = await axios.put(`/api/smart-fields/group-member/${groupMemberId}`, { smartFields });

    dispatch(addNotification(
      UPDATE_GROUP_MEMBER_SMART_FIELDS_SUCCESS,
      'Smart fields updated successfully',
      NOTIFICATION_STATUS.SUCCESS
    ));
    dispatch({
      type: UPDATE_GROUP_MEMBER_SMART_FIELDS_SUCCESS,
      payload: response?.data || {},
    });

    if (doWhenTry) {
      doWhenTry(response?.data);
    }
    return response?.data;
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(
      UPDATE_GROUP_MEMBER_SMART_FIELDS_ERROR,
      helpers.transform.toString(message || error || 'Failed to update smart fields'),
      NOTIFICATION_STATUS.ERROR
    ));
    dispatch({
      type: UPDATE_GROUP_MEMBER_SMART_FIELDS_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
    return null;
  }
};

/**
 * clearGroupMemberSmartFields
 * Clears the group member smart fields from state
 */
export const clearGroupMemberSmartFields = () => ({
  type: CLEAR_GROUP_MEMBER_SMART_FIELDS,
});

/**
 * getPartyGuestSmartFields
 * Fetches the smart field values for a specific party guest
 */
export const getPartyGuestSmartFields = (partyGuestId) => async (dispatch) => {
  dispatch({
    type: GET_PARTY_GUEST_SMART_FIELDS,
  });
  try {
    const response = await axios.get(`/api/smart-fields/party-guest/${partyGuestId}`);
    dispatch({
      type: GET_PARTY_GUEST_SMART_FIELDS_SUCCESS,
      payload: response?.data || {},
    });
    return response?.data;
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(
      GET_PARTY_GUEST_SMART_FIELDS_ERROR,
      helpers.transform.toString(message || error || 'Failed to load smart fields'),
      NOTIFICATION_STATUS.ERROR
    ));
    dispatch({
      type: GET_PARTY_GUEST_SMART_FIELDS_ERROR,
    });
    return null;
  }
};

/**
 * updatePartyGuestSmartFields
 * Updates the smart field values for a specific party guest
 */
export const updatePartyGuestSmartFields = (
  partyGuestId,
  smartFields,
  doWhenTry = false,
  doWhenCatch = false
) => async (dispatch) => {
  dispatch({
    type: UPDATE_PARTY_GUEST_SMART_FIELDS,
  });
  try {
    const response = await axios.put(`/api/smart-fields/party-guest/${partyGuestId}`, { smartFields });

    dispatch(addNotification(
      UPDATE_PARTY_GUEST_SMART_FIELDS_SUCCESS,
      'Smart fields updated successfully',
      NOTIFICATION_STATUS.SUCCESS
    ));
    dispatch({
      type: UPDATE_PARTY_GUEST_SMART_FIELDS_SUCCESS,
      payload: response?.data || {},
    });

    if (doWhenTry) {
      doWhenTry(response?.data);
    }
    return response?.data;
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(
      UPDATE_PARTY_GUEST_SMART_FIELDS_ERROR,
      helpers.transform.toString(message || error || 'Failed to update smart fields'),
      NOTIFICATION_STATUS.ERROR
    ));
    dispatch({
      type: UPDATE_PARTY_GUEST_SMART_FIELDS_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
    return null;
  }
};

/**
 * clearPartyGuestSmartFields
 * Clears the party guest smart fields from state
 */
export const clearPartyGuestSmartFields = () => ({
  type: CLEAR_PARTY_GUEST_SMART_FIELDS,
});

/**
 * getContactSmartFields
 * Fetches the smart field values for a specific contact
 */
export const getContactSmartFields = (contactId) => async (dispatch) => {
  dispatch({
    type: GET_CONTACT_SMART_FIELDS,
  });
  try {
    const response = await axios.get(`/api/smart-fields/contact/${contactId}`);
    dispatch({
      type: GET_CONTACT_SMART_FIELDS_SUCCESS,
      payload: response?.data || {},
    });
    return response?.data;
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(
      GET_CONTACT_SMART_FIELDS_ERROR,
      helpers.transform.toString(message || error || 'Failed to load smart fields'),
      NOTIFICATION_STATUS.ERROR
    ));
    dispatch({
      type: GET_CONTACT_SMART_FIELDS_ERROR,
    });
    return null;
  }
};

/**
 * updateContactSmartFields
 * Updates the smart field values for a specific contact
 */
export const updateContactSmartFields = (
  contactId,
  smartFields,
  doWhenTry = false,
  doWhenCatch = false
) => async (dispatch) => {
  dispatch({
    type: UPDATE_CONTACT_SMART_FIELDS,
  });
  try {
    const response = await axios.put(`/api/smart-fields/contact/${contactId}`, { smartFields });

    dispatch(addNotification(
      UPDATE_CONTACT_SMART_FIELDS_SUCCESS,
      'Smart fields updated successfully',
      NOTIFICATION_STATUS.SUCCESS
    ));
    dispatch({
      type: UPDATE_CONTACT_SMART_FIELDS_SUCCESS,
      payload: response?.data || {},
    });

    if (doWhenTry) {
      doWhenTry(response?.data);
    }
    return response?.data;
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(
      UPDATE_CONTACT_SMART_FIELDS_ERROR,
      helpers.transform.toString(message || error || 'Failed to update smart fields'),
      NOTIFICATION_STATUS.ERROR
    ));
    dispatch({
      type: UPDATE_CONTACT_SMART_FIELDS_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
    return null;
  }
};

/**
 * clearContactSmartFields
 * Clears the contact smart fields from state
 */
export const clearContactSmartFields = () => ({
  type: CLEAR_CONTACT_SMART_FIELDS,
});
